"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshToken = exports.resetPassword = exports.forgetPassword = exports.signIn = void 0;

var _axios = _interopRequireDefault(require("axios")); // TODO: add trailing slash function to utils and pass in endpoint via settings (doesn't need to be /graphql)


var getEndpoint = function getEndpoint(url) {
  return "".concat(url.replace(/\/+$/, ''), "/graphql");
};

var signIn = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, url) {
    var email, password, endpoint, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            email = _ref.email, password = _ref.password;
            _context.prev = 1;
            endpoint = getEndpoint(url);
            _context.next = 5;
            return _axios.default.post(endpoint, {
              query: "\n        mutation  {\n          login(\n            input: {\n              username: \"".concat(email, "\"\n              password: \"").concat(password, "\"\n              clientMutationId: \"login\"\n            }\n          ) {\n            authToken\n            refreshToken\n            user{\n              capabilities\n            }\n          }\n        }\n      ")
            });

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result === null || result === void 0 ? void 0 : result.data);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            console.log(_context.t0);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function signIn(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

exports.signIn = signIn;

var forgetPassword = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, url) {
    var email, endpoint, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            email = _ref2.email;
            endpoint = getEndpoint(url);
            _context2.next = 4;
            return _axios.default.post(endpoint, {
              query: "\n      mutation {\n        sendPasswordResetEmail(\n          input: {\n            username: \"".concat(email, "\"\n            clientMutationId: \"forgotPassword\"\n          }\n        ) {\n          user {\n            email\n          }\n        }\n      }\n    ")
            });

          case 4:
            result = _context2.sent;
            return _context2.abrupt("return", result === null || result === void 0 ? void 0 : result.data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function forgetPassword(_x3, _x4) {
    return _ref6.apply(this, arguments);
  };
}();

exports.forgetPassword = forgetPassword;

var resetPassword = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, url) {
    var key, login, password, endpoint, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            key = _ref3.key, login = _ref3.login, password = _ref3.password;
            endpoint = getEndpoint(url);
            _context3.next = 4;
            return _axios.default.post(endpoint, {
              query: "\n      mutation {\n        resetUserPassword(\n          input: {\n            key: \"".concat(key, "\"\n            login: \"").concat(login, "\"\n            password: \"").concat(password, "\"\n            clientMutationId: \"changePassword\"\n          }\n        ) {\n          user {\n            email\n          }\n        }\n      }\n    ")
            });

          case 4:
            result = _context3.sent;
            return _context3.abrupt("return", result === null || result === void 0 ? void 0 : result.data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function resetPassword(_x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}();

exports.resetPassword = resetPassword;

var refreshToken = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, url) {
    var refreshToken, endpoint, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            refreshToken = _ref4.refreshToken;
            endpoint = getEndpoint(url);
            _context4.next = 4;
            return _axios.default.post(endpoint, {
              query: "\n      mutation {\n        refreshJwtAuthToken(\n          input: {\n            jwtRefreshToken: \"".concat(refreshToken, "\"\n            clientMutationId: \"refreshToken\"\n          }\n        ) {\n          authToken\n        }\n      }\n    ")
            });

          case 4:
            result = _context4.sent;
            return _context4.abrupt("return", result === null || result === void 0 ? void 0 : result.data);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function refreshToken(_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}();

exports.refreshToken = refreshToken;